import { render, staticRenderFns } from "./GridCertificados.vue?vue&type=template&id=5a14257e&"
import script from "./GridCertificados.vue?vue&type=script&lang=js&"
export * from "./GridCertificados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports